import { getDictionary } from '../utils';

export async function getDictionaryByLocale(locale = '') {
  return await getDictionary('./Polestar/dictionaries', locale);
}
